import { InjectionToken } from "@angular/core";

export interface SlideSyncToolbarConfig {
    colorPalette: { color: string }[];
    colorDefault: string;
}
export const SLIDE_SYNC_TOOLBAR_CONFIG = new InjectionToken<SlideSyncToolbarConfig>('SLIDE_SYNC_TOOLBAR_CONFIG');